import { createContext as t } from "react";
var o = t(!0);
export {
  o as FocusableContext
};
//# sourceMappingURL=SWN3JYXT.js.map
